import { useEffect, useState } from 'react';

interface RotatingWordProps {
  words: string[];
  interval?: number;
  className?: string;
}

/** Cross-fades between words in place, sized to the longest word to avoid layout shift. */
export const RotatingWord = ({ words, interval = 2600, className }: RotatingWordProps) => {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (words.length < 2) return;
    const id = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex((i) => (i + 1) % words.length);
        setVisible(true);
      }, 320);
    }, interval);
    return () => window.clearInterval(id);
  }, [words, interval]);

  return (
    <span className="relative inline-grid align-baseline">
      {/* Invisible sizer: longest word reserves the space */}
      {words.map((w) => (
        <span key={w} className="col-start-1 row-start-1 invisible whitespace-nowrap" aria-hidden="true">
          {w}
        </span>
      ))}
      <span
        className={`col-start-1 row-start-1 whitespace-nowrap transition-all duration-300 ease-out ${
          visible ? 'opacity-100 translate-y-0 blur-0' : 'opacity-0 -translate-y-1 blur-[2px]'
        } ${className ?? ''}`}
      >
        {words[index]}
      </span>
      <span className="sr-only">{words.join(', ')}</span>
    </span>
  );
};

export default RotatingWord;
